const BTN = 'px-3 py-1 text-xs rounded text-[#888] hover:text-[#CCC] hover:bg-[#2A2A2A] disabled:opacity-30 disabled:cursor-not-allowed';

interface UndoRedoButtonsProps {
  canUndo: boolean;
  onUndo: () => void;
  canRedo: boolean;
  onRedo: () => void;
}

export const UndoRedoButtons = ({ canUndo, onUndo, canRedo, onRedo }: UndoRedoButtonsProps) => (
  <>
    <button onClick={onUndo} disabled={!canUndo} title="Undo (Ctrl+Z)" className={BTN}>
      ↩ Undo
    </button>
    <button onClick={onRedo} disabled={!canRedo} title="Redo (Ctrl+Y)" className={BTN}>
      ↪ Redo
    </button>
  </>
);
